import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { SavedItemsPage } from '#src/pages/SavedItemsPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/saved')({
  component: RouteComponent
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'head.saved-items',
            defaultMessage: 'Saved'
          })}
        </title>
      </Head>

      <SavedItemsPage />
    </>
  );
}
